module.exports = __webpack_public_path__ + "static/media/sidebar-6.4779127a.jpg";